// src/hooks/useSuspendReactivateAdmin.js
import { useState } from "react";
import { toast } from "react-toastify";
import requestDemoService from "../services/requestDemoService"; 
// If OrganisationContent uses a different service, we'll handle it below

export const useSuspendReactivateAdmin = (onSuccess = () => {}) => {
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [selectedOrgAdminId, setSelectedOrgAdminId] = useState(null);
  const [reason, setReason] = useState("");
  const [isSuspending, setIsSuspending] = useState(false);
  const [isReactivating, setIsReactivating] = useState(false);

  const openSuspendModal = (orgAdminId) => {
    setSelectedOrgAdminId(orgAdminId);
    setReason("");
    setShowSuspendModal(true);
  };

  const closeSuspendModal = () => {
    setShowSuspendModal(false);
    setSelectedOrgAdminId(null);
    setReason("");
  };

  const suspendAdmin = async () => {
    if (!reason.trim()) {
      toast.error("Please provide a reason for suspension");
      return;
    }

    setIsSuspending(true);
    try {
      await requestDemoService.suspendOrgAdmin(selectedOrgAdminId, reason);
      toast.success("Admin suspended successfully!");
      closeSuspendModal();
      onSuccess();
    } catch (error) {
      const msg = error.message || "Failed to suspend admin";
      toast.error(msg);
    } finally {
      setIsSuspending(false);
    }
  };

  const reactivateAdmin = async (orgAdminId) => {
    setIsReactivating(true);
    try {
      await requestDemoService.reactivateOrgAdmin(orgAdminId);
      toast.success("Admin reactivated successfully!");
      onSuccess();
    } catch (error) {
      const msg = error.message || "Failed to reactivate admin";
      toast.error(msg);
    } finally {
      setIsReactivating(false);
    }
  };

  return {
    // Modal
    showSuspendModal,
    openSuspendModal,
    closeSuspendModal,
    reason,
    setReason,
    isSuspending,

    // Actions
    suspendAdmin,
    reactivateAdmin,
    isReactivating,
  };
};